import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Header from '../components/Header';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { fetchStores } from '../services/api';
import { Store } from '../config/types';

function AddressesPage() {
  const { language, setLanguage } = useLanguage();
  const [stores, setStores] = useState<Store[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStores = async () => {
      try {
        const data = await fetchStores();
        setStores(data);
      } catch (err) {
        console.error('Ошибка при загрузке магазинов', err);
      } finally {
        setLoading(false);
      }
    };
    loadStores();
  }, []);

  return (
    <div className="App">
      <Header />
      <LanguageSwitcher language={language} setLanguage={setLanguage} />

      <main className="addresses-content">
        <h1 className="addresses-title">
          {language === 'ru' ? 'Адреса 2GIS' : '2GIS мекенжайлары'}
          <img src="/2gis.webp" alt="2GIS" className="gis-icon" />
        </h1>

        {loading ? (
          <p>{language === 'ru' ? 'Загрузка…' : 'Жүктелуде…'}</p>
        ) : (
          <div className="addresses-list">
            {stores.map((store) => (
              <a
                key={store.code}
                href={store.address_2gis}
                className="address-item"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="address-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="white"/>
                  </svg>
                </span>
                <span className="address-text">
                  {language === 'ru' ? store.name_ru : store.name_kz}
                </span>
                <span className="address-arrow">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z" fill="white"/>
                  </svg>
                </span>
              </a>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

export default AddressesPage;









// const addresses = [
//   { id: 'Q1', ru: '(ул.Шаймерденова д.29) QB', kz: '(к-сі.Шаймерденов ү.29) QB', link: stores.Q1.link2gis },
//   { id: 'Q3', ru: 'Микрорайон Аксай-5,25', kz: 'Ақсай-5 шағын ауданы, 25', link: stores.Q3.link2gis },
//   { id: 'Q4', ru: '3 мкр. д.20А уг.Абая-Саина', kz: '3 мкр. д.20А уг.Абая-Саина', link: stores.Q4.link2gis },
//   { id: 'Q5', ru: 'ул.Толеби д.75/ уг.Сейфуллина 472', kz: 'ул.Толеби д.75/ уг.Сейфуллина 472', link: stores.Q5.link2gis },
//   { id: 'Q6', ru: 'пос.Баганашыл ул.Сыргабекова д.22Б', kz: 'пос.Баганашыл ул.Сыргабекова д.22Б', link: stores.Q6.link2gis },
//   { id: 'Q7', ru: 'Улица Розыбакиева, 320', kz: 'Розыбакиев көшесі, 320', link: stores.Q7.link2gis },
//   { id: 'Q8', ru: 'пос.Акжар ул.Егинсу д.29/12', kz: 'пос.Акжар ул.Егинсу д.29/12', link: stores.Q8.link2gis },
//   { id: 'Q9', ru: 'мкр.Мамыр-1 д.8а, ТЦ Спутник', kz: 'Розыбакиев көшесі, 75', link: stores.Q9.link2gis },
//   { id: 'Q10', ru: 'ул.Жунисова д.8/11, ЖК АлмаСити', kz: 'ул.Жунисова д.8/11, ЖК АлмаСити', link: stores.Q10.link2gis },
//   { id: 'Q11', ru: 'мкр.Думан ул.Есил .5А', kz: 'мкр.Думан ул.Есил .5А', link: stores.Q11.link2gis },
//   { id: 'Q12', ru: 'Илийск.р-н Водник ул.Алатау д.2', kz: 'Илийск.р-н Водник ул.Алатау д.2', link: stores.Q12.link2gis },
//   { id: 'Q13', ru: 'мкр.Айнабулак-1 д.9А', kz: 'мкр.Айнабулак-1 д.9А', link: stores.Q13.link2gis },
//   { id: 'Q14', ru: 'Наурыз.р-н ,Таусамалы микрорайон, 98 микрорайон Шугыла, 154)', kz: 'Наурыз.р-н ,Таусамалы микрорайон, 98 микрорайон Шугыла, 154)', link: stores.Q14.link2gis },
//   { id: 'Q15', ru: 'мкр.Казахфильм ул.Вишневая д.16/2', kz: 'мкр.Казахфильм ул.Вишневая д.16/2', link: stores.Q15.link2gis },
//   { id: 'Q16', ru: 'ул.Шолохова д.2', kz: 'Айманов көшесі, 2/1', link: stores.Q16.link2gis },
//   { id: 'Q17', ru: 'ул.Розыбакиева д.75, маг.Карасу', kz: 'Розыбакиев көшесі, 75', link: stores.Q17.link2gis },
//   { id: 'Q18', ru: 'мкр.Жетысу-3 д.24', kz: 'мкр.Жетысу-3 д.24', link: stores.Q18.link2gis },
//   { id: 'Q19', ru: 'Илийск. р-н, с.Отеген батыра, ул. Жансүгіров, уч.159', kz: 'АИлийск. р-н, с.Отеген батыра, ул. Жансүгіров, уч.159', link: stores.Q19.link2gis },
//   { id: 'Q20', ru: 'ул.Толе би, д.181, н.п.309', kz: 'ул.Толе би, д.181, н.п.309', link: stores.Q20.link2gis },
//   { id: 'Q21', ru: 'пр.Гагарина, д.124, н.п.769-1', kz: 'пр.Гагарина, д.124, н.п.769-1', link: stores.Q21.link2gis },
//   { id: 'Q22', ru: 'Саялы ул. Аккайын, 2/1', kz: 'Саялы ул. Аккайын, 2/1', link: stores.Q22.link2gis }
// ];